// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ellipsis-container {
  color: #676e7b;
  overflow: hidden;
  text-align: justify;
  position: relative;
  font: normal normal 600 16px/23px Manrope;
}

.ellipsis-content {
  display: block;
  max-height: 100%;
  padding-right: 1em;
  font-size: 14px;
  font-weight: 400;
  text-align: justify;
  cursor: pointer;
  color: #5a5f67 !important;
}

.ellipsis-overlay {
  position: absolute;
  bottom: 0;
  right: 0;
  background: white;
  padding-right: 0.5em;
}

.ellipsis-overlay::after {
  content: "...Read more";
  color: #bfbfbf;
}

.read-more {
  color: #bfbfbf;
  padding-left: 0.5em;
}

.carousel .slide .legend {
  background: rgba(103, 110, 123, 0.4) !important;
  opacity: 1 !important;
  left: 45% !important;
  width: 100% !important;
  border-radius: 0px !important;
}

.custom-read-more {
  color: #bfbfbf;
  cursor: pointer;
}

.text-decoration-none {
  color: inherit;
}

.av-size {
  height: 20px !important;
  width: 20px !important;
  font-size: 12px !important;
}

.css-lrmc1p-MuiAvatar-root-MuiAvatarGroup-avatar {
  height: 20px !important;
  width: 20px !important;
  font-size: 12px !important;
  display: none !important;
}

.css-11hi88g-MuiAvatarGroup-root .MuiAvatar-root {
  border: none !important;
  box-sizing: content-box;
  margin-left: -8px;
  height: 20px !important;
  width: 20px !important;
  font-size: 12px !important;
}

.MuiAvatar-root.MuiAvatar-circular.MuiAvatar-colorDefault.MuiAvatarGroup-avatar.css-o5qrff-MuiAvatar-root-MuiAvatarGroup-avatar {
  display: none !important;
}

@media only screen and (max-width: 450px) {
  .btn-urg {
    margin-left: 0px !important;
    margin-top: 6px !important;
  }
  .postby-font {
    font-size: 15px !important;
  }
}
video::-webkit-media-controls-timeline {
  margin-bottom: 22px;
}

.brk-txt {
  width: 400px;
  overflow-wrap: break-word;
  text-wrap: pretty;
}

@media only screen and (max-width: 640px) {
  .brk-txt {
    width: 330px;
  }
}
@media only screen and (max-width: 480px) {
  .brk-txt {
    width: 315px;
  }
}
@media only screen and (max-width: 450px) {
  .brk-txt {
    width: 236px;
  }
}
@media only screen and (max-width: 990px) {
  .responsive-p {
    padding-bottom: 30px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/common/cards/activity-recurring-card/activity-recurring-card.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,yCAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,mBAAA;AAAF;;AAGA;EACE,+CAAA;EACA,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,uBAAA;EACA,sBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,wBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;AAAF;;AAIA;EACE,wBAAA;AADF;;AAIA;EACE;IACE,2BAAA;IACA,0BAAA;EADF;EAIA;IACE,0BAAA;EAFF;AACF;AAKA;EACE,mBAAA;AAHF;;AAMA;EACE,YAAA;EACA,yBAAA;EACA,iBAAA;AAHF;;AAMA;EACE;IACE,YAAA;EAHF;AACF;AAMA;EACE;IACE,YAAA;EAJF;AACF;AAOA;EACE;IACE,YAAA;EALF;AACF;AAQA;EACE;IACE,+BAAA;EANF;AACF","sourcesContent":[".ellipsis-container {\n  color: #676e7b;\n  overflow: hidden;\n  text-align: justify;\n  // height: 70px;\n  position: relative;\n  font: normal normal 600 16px/23px Manrope;\n}\n\n.ellipsis-content {\n  display: block;\n  max-height: 100%;\n  padding-right: 1em;\n  font-size: 14px;\n  font-weight: 400;\n  text-align: justify;\n  cursor: pointer;\n  color: #5a5f67 !important;\n}\n\n.ellipsis-overlay {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  background: white;\n  padding-right: 0.5em;\n}\n\n.ellipsis-overlay::after {\n  content: '...Read more';\n  color: #bfbfbf;\n}\n\n.read-more {\n  color: #bfbfbf;\n  padding-left: 0.5em;\n}\n\n.carousel .slide .legend {\n  background: rgba(103, 110, 123, 0.4) !important;\n  opacity: 1 !important;\n  left: 45% !important;\n  width: 100% !important;\n  border-radius: 0px !important;\n}\n\n.custom-read-more {\n  color: #bfbfbf;\n  cursor: pointer;\n}\n\n.text-decoration-none {\n  color: inherit;\n}\n\n.av-size {\n  height: 20px !important;\n  width: 20px !important;\n  font-size: 12px !important;\n}\n\n.css-lrmc1p-MuiAvatar-root-MuiAvatarGroup-avatar {\n  height: 20px !important;\n  width: 20px !important;\n  font-size: 12px !important;\n  display: none !important;\n}\n\n.css-11hi88g-MuiAvatarGroup-root .MuiAvatar-root {\n  border: none !important;\n  box-sizing: content-box;\n  margin-left: -8px;\n  height: 20px !important;\n  width: 20px !important;\n  font-size: 12px !important;\n  // display: none !important;\n}\n\n.MuiAvatar-root.MuiAvatar-circular.MuiAvatar-colorDefault.MuiAvatarGroup-avatar.css-o5qrff-MuiAvatar-root-MuiAvatarGroup-avatar {\n  display: none !important;\n}\n\n@media only screen and (max-width: 450px) {\n  .btn-urg {\n    margin-left: 0px !important;\n    margin-top: 6px !important;\n  }\n\n  .postby-font {\n    font-size: 15px !important;\n  }\n}\n\nvideo::-webkit-media-controls-timeline {\n  margin-bottom: 22px;\n}\n\n.brk-txt {\n  width: 400px;\n  overflow-wrap: break-word;\n  text-wrap: pretty;\n}\n\n@media only screen and (max-width: 640px) {\n  .brk-txt {\n    width: 330px;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .brk-txt {\n    width: 315px;\n  }\n}\n\n@media only screen and (max-width: 450px) {\n  .brk-txt {\n    width: 236px;\n  }\n}\n\n@media only screen and (max-width: 990px) {\n  .responsive-p {\n    padding-bottom: 30px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
